<header class="header">
    <card-header
        title="{{ ('CASES.CPSU.'+(data.modalType=='CONNECT'?'CONNECT_FOSTER_CHILD':'DISCONNECT_FOSTER_CHILD')) | translate }}">
    </card-header>
    <div *ngIf="data.modalType=='CONNECT'" class="header__actions">
        <form class="form" [formGroup]="fosterChildCpsuForm" style="width: 100%;">
            <field-holder>
                <mat-form-field appearance="outline">
                    <mat-label>{{'GLOBAL.CENTER' | translate}}</mat-label>
                    <mat-select formControlName="center" required>
                        <mat-option *ngFor="let value of centers" [value]="value?.id">
                            {{ value.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="fosterChildCpsuForm.get('center').hasError('required')">
                        {{ "GLOBAL.CENTER_ERROR" | translate }}
                    </mat-error>
                </mat-form-field>
            </field-holder>
            <field-holder>
                <mat-form-field appearance="outline">
                    <mat-label>{{ 'CASES.CPSU.FOSTER_CHILD' | translate }}</mat-label>
                    <input matInput type="text" formControlName="fosterChildData" readonly>
                </mat-form-field>
            </field-holder>
            <field-holder>
                <mat-form-field appearance="outline">
                    <mat-label>{{ 'CASES.CPSU.FOSTER_PARENT' | translate }}</mat-label>
                    <input matInput type="text" formControlName="fosterParentData" [matAutocomplete]="autoFosterParent"
                        required  />
                    <mat-autocomplete #autoFosterParent="matAutocomplete" [displayWith]="displayCustomFormat">
                        <mat-option *ngFor="let fosterParent of filteredFosterParent | async" [value]="fosterParent">
                            {{fosterParent.firstName}} {{fosterParent.lastName}}, {{fosterParent.jmbg}}
                        </mat-option>
                    </mat-autocomplete>
                       <mat-error *ngIf="fosterChildCpsuForm.get('fosterParentData').hasError('invalidFosterParent')">
                            {{ "CASES.CPSU.SELECT_FOSTER_PARENT" | translate }}
                        </mat-error>
                </mat-form-field>
            </field-holder>
            <form-footer>
                <button mat-stroked-button color="primary" class="form-footer__button" (click)="sendRequest()"
                    [disabled]="!fosterChildCpsuForm.valid || fosterChildCpsuForm.get('fosterParentData').value==null || fosterChildCpsuForm.get('fosterParentData').value.id==null || fosterChildCpsuForm.get('fosterParentData').value.id==undefined">
                    {{ 'SIDEBAR_WIDGET.OTHER_INSTITUTIONS.SUBMIT' | translate }}
                </button>
                <button mat-stroked-button color="primary" mat-dialog-close (click)="closeDialog()"
                    class="modal-footer__button modal-footer__button--secondary">
                    {{ 'WARNING_DIALOG.CANCEL' | translate }}
                </button>
            </form-footer>
        </form>
    </div>
    <div *ngIf="data.modalType=='DISCONNECT'" class="header__actions">
        <p class="modal__content" style="white-space: pre-wrap;">
            {{ 'CASES.CPSU.DISCONNECT_FOSTER_CHILD_CONFIRM' | translate}}
        </p>
        <form-footer>
            <button mat-flat-button color="warn" class="form-footer__button" (click)="disconectFosterSubject()">
                {{"WARNING_DIALOG.SUBMIT" | translate }}
            </button> 
            <button mat-stroked-button color="primary" mat-dialog-close (click)="closeDialog()"
                class="modal-footer__button modal-footer__button--secondary">
                {{ 'WARNING_DIALOG.CANCEL' | translate }}
            </button>
        </form-footer>
    </div>
</header>